import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "tray"];
import React, { useContext, useEffect, useState } from 'react';
import { Menu } from 'semantic-ui-react';
import { TRAY_OPEN_CLOSE_DURATION } from './Container.constants';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import AnimateHeight from '../../../../../animations/components/AnimatedElement/variants/AnimateHeight';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import { NavigationContext } from '../../Navigation.context';
import './Container.css';
var defaultProps = {
  className: '',
  tray: false
};
export default function Container(_ref) {
  var _classNames;
  var children = _ref.children,
    className = _ref.className,
    tray = _ref.tray,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(NavigationContext),
    toggled = _useContext.toggled;
  var _useSemanticUiProps = useSemanticUiProps(),
    getMenuProps = _useSemanticUiProps.getMenuProps;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    displayNoneTray = _useState2[0],
    setDisplayNoneTray = _useState2[1];
  var hidden = tray && !toggled;
  useEffect(function () {
    if (hidden) {
      setDisplayNoneTray(false);
      setTimeout(function () {
        // added this to fix issue of the tray flashing when it gets closed
        setDisplayNoneTray(true);
      }, 100);
    }
  }, [hidden]);
  var menuProps = getMenuProps(props);
  var finalClassName = classNames((_classNames = {
    container: true,
    tray: tray
  }, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "hidden", hidden), _defineProperty(_classNames, 'display-none', !displayNoneTray), _defineProperty(_classNames, "toggled", toggled), _classNames));
  var MenuContainer = /*#__PURE__*/React.createElement(Menu, _extends({
    borderless: true,
    className: finalClassName
  }, menuProps), children);
  if (tray) {
    return /*#__PURE__*/React.createElement(AnimateHeight, {
      duration: TRAY_OPEN_CLOSE_DURATION,
      height: hidden ? '0' : 'auto',
      disableAnimation: hidden
    }, MenuContainer);
  }
  return MenuContainer;
}
Container.defaultProps = defaultProps;